import Vue from 'vue'
import App from '@/pages/goldkid/App.vue'
import store from '@/store'
import translateKey from '@/filters/translate.filter'
import translateLoc from '@/filters/translateLoc.filter'
import parseToInt from '@/filters/parseToInt.filter'
import translateMixin from '@/mixins/translateMixin'
import localeMixin from '@/mixins/localeMixin'
import '@/pages/goldkid/authCallbacks'
import '@/pages/goldkid/axios'
import '@/pages/sentry'
import '@/pages/goldkid/smoothscroll'

import * as DsComponents from '@ds/vue2'

for (const componentKey in DsComponents) {
  Vue.component(componentKey, DsComponents[componentKey])
}

Vue.config.productionTip = false
import "@ds/core-styles-web";
import "@ds/vue2/styles";
Vue.filter('translate', translateKey)
Vue.filter('translateLoc', translateLoc)
Vue.filter('parseToInt', parseToInt)

Vue.mixin(translateMixin)
Vue.mixin(localeMixin)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
